import React, { FC } from "react";
import { useSearchParams } from "react-router-dom";

import { Box, Tab, Tabs } from "@mui/material";

import Header from "../../components/Header";
import Page from "../../components/Page";
import ChangesList from "./ChangesList";
import ChangesetsList from "./ChangesetsList";

const tabDefinitions = [
  {
    value: "changes",
    label: "Changes",
    component: () => <ChangesList />,
  },
  {
    value: "changesets",
    label: "Changesets",
    component: () => <ChangesetsList />,
  },
];

const List: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab =
    tabDefinitions.find((t) => t.value === searchParams.get("tab")) ||
    tabDefinitions[0];

  function handleChangeTab(_: React.SyntheticEvent, newValue: string) {
    setSearchParams({
      tab: newValue,
    });
  }

  return (
    <Page title="Deployments">
      <Header title="Deployments" breadcrumbs={true} />

      <Box>
        <Tabs value={tab.value} onChange={handleChangeTab}>
          {tabDefinitions.map((t) => (
            <Tab key={t.value} label={t.label} value={t.value} />
          ))}
        </Tabs>
      </Box>

      {tab.component()}
    </Page>
  );
};
export default List;
